<template>
    <button class="button button--corner" v-on="$listeners">
      <CloseSVG />
    </button>
</template>

<script>
  import CloseSVG from '@/components/svg/CloseSVG'

  export default {
    components: {
      CloseSVG,
    }
  }
</script>

<style scoped lang="scss">
  .button {
    background: lighten(#000, 80);
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 2px solid #fff;

    svg { 
      width: 60%; 
      fill: #fff 
    }

    &--corner {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(20%, -30%);
    }
  }
</style>